"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
const codeMirrorUtils_1 = require("./codeMirrorUtils");
function useCreateCodeMirror({ codeMirrorRef, initialValue, placeholder, onEscape, selectedTagPosRef, textBoxRef, }) {
    const valueRef = react_1.useRef(lodash_1.toString(initialValue));
    react_1.useLayoutEffect(() => {
        const codeMirrorConstructor = require('codemirror');
        require('codemirror/addon/display/placeholder');
        const codeMirror = codeMirrorUtils_1.createCodeMirror({
            codeMirrorConstructor,
            node: textBoxRef.current,
            placeholder,
            value: valueRef.current || '',
        });
        codeMirrorRef.current = codeMirror;
        codeMirror.on('mousedown', () => {
            selectedTagPosRef.current = undefined;
        });
        codeMirror.on('keydown', (_, event) => {
            if (event.key === 'Escape') {
                onEscape();
            }
        });
        return () => {
            codeMirrorRef.current = null;
        };
    }, [codeMirrorRef, placeholder, onEscape, selectedTagPosRef, textBoxRef]);
}
exports.default = useCreateCodeMirror;
